// view-source: https://cozmo.github.io/jsQR/
import React, { Component } from 'react';
import BarcodeReader from 'react-barcode-reader';
import { connect } from 'react-redux';
import { addScan } from 'store/actions/barcode';
import cx from 'classnames';
import jsQR from "jsqr";
import * as moment from 'moment-timezone';

class Barcode extends Component {

  canvasRef = null;
  videoRef = null;

  constructor(props){
    super(props)
    this.state = {
      result: null,
      loaded: false,
      outputMessage: 'Unable to access video stream (please make sure you have a webcam enabled or use a USB barcode scanner)',
    }
  }

  componentDidMount() {

    this.videoRef = document.createElement("video");
    const self = this;

    // Use facingMode: environment to attemt to get the rear camera on phones
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      
      navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } })
      .then(stream => {
        
        self.videoRef.srcObject = stream;
        self.videoRef.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        self.videoRef.play();

        self.setState({ outputMessage: "Loading video..." });
        window.requestAnimationFrame(self.tick);
      })
      .catch(e => console.warn(e.message));
    
    }
  }

  tick = async () => {

    const { addScan, barcode, login } = this.props;

    if (!this.canvasRef) {
      return;
    }

    const canvas = this.canvasRef.getContext("2d", { willReadFrequently: true });

    if (this.videoRef.readyState === this.videoRef.HAVE_ENOUGH_DATA) {
      
      const newState = {};
      if (!this.state.loaded)
        newState.loaded = true;
      if (this.state.outputMessage.length>0)
        newState.outputMessage = '';
      if (Object.keys(newState).length>0)
        this.setState(newState);

      this.canvasRef.height = this.videoRef.videoHeight;
      this.canvasRef.width = this.videoRef.videoWidth;

      canvas.drawImage(this.videoRef, 0, 0, this.canvasRef.width, this.canvasRef.height);
      const imageData = canvas.getImageData(0, 0, this.canvasRef.width, this.canvasRef.height);

      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });
      
      if (code!==null && code.data.length>0 && !this.props.loading) {

        // console.log({code});

        this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
        this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
        this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
        this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");

        // add scan to scan history
        addScan(code.data);
        
        // scanned in the last 3 seconds
        const alreadyScanned = barcode.reduce((acc, scan) => {
          const { code: scanCode, time } = scan;
          return acc || ( code.data === scanCode && moment().subtract(3, 'second').isBefore(moment(time)));
        }, false);

        if (!alreadyScanned) {
          await login(code.data);
        }

      } else {

        // this.setState({ result: null });
      }
      
    }

    window.requestAnimationFrame(this.tick);
  }

  drawLine = (begin, end, color) => {

    // const canvas = this.canvasRef.getContext("2d");

    // canvas.beginPath();
    // canvas.moveTo(begin.x, begin.y);
    // canvas.lineTo(end.x, end.y);
    // canvas.lineWidth = 4;
    // canvas.strokeStyle = color;
    // canvas.stroke();
  }

  handleScan = data => {

    // console.log({ data });

    const { addScan, barcode, login } = this.props;

    // Totally text reader
    // {"barcode":"16766_2534326818a353e8d92db5e45f39908e_1654036474_inf"}
    // Reader installed at Youth Center
    // {"barcode":\\00002616021_556971330dfde78cde2163783ca53e58_1654036469_inf}
    // https://4js.com/online_documentation/fjs-gst-2.50.02-manual-html/c_grd_barcodes_qr_code.html
    // Start code of 26 represents UTF-8 encoding
    // This comes in as purely text, not a character, filter the characters if applicable
    const prefix = "\\000026";
    if (data.indexOf(prefix) === 0) {
      data = data.substr(prefix.length);
    }

    // add scan to scan history
    addScan(data);
        
    // scanned in the last 3 seconds
    const alreadyScanned = barcode.reduce((acc, scan) => {
      const { code: scanCode, time } = scan;
      return acc || ( data === scanCode && moment().subtract(3, 'second').isBefore(moment(time)));
    }, false);

    if (!alreadyScanned) {
      login(data);
    }
  }

  handleKeyDetect = e => console.log({e, which: e.which, key: e.key, keyCode: e.keyCode});

  render() {

    const { loaded, outputMessage, result } = this.state;

    return (
      <div 
        className={cx({
          Barcode: true,
          loaded: loaded,
        })}
      >
        {/* Webcam scan */}
        <canvas 
          className="canvas"
          ref={ref => {
            // console.log(ref);
            this.canvasRef = ref;
          }}
        ></canvas>
        <div className="outputMessage">{outputMessage}</div>
        <div className="outputData">{result}</div>
        {/* Keyboard Scan */}
        <BarcodeReader
          onScan={this.handleScan}
          minLength={38}
          stopPropagation={true}
          // onKeyDetect={this.handleKeyDetect}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  
  const { 
    auth: { isFetching },
    barcode,
  } = state;

  return {
    barcode,
    loading: isFetching, // dont scan when we are doing other stuff
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addScan: code => dispatch(addScan(code)),
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Barcode);